import { Component } from '@angular/core';

import { PeopleListComponent } from '../people-list/people-list.component';
import { PeopleTabConfig } from '../people-list/people-tab-config';

@Component({
    selector: 'app-people-crew',
    standalone: true,
    imports: [PeopleListComponent],
    template: `<app-people-list [config]="config"></app-people-list>`,
})
export class PeopleCrewComponent {
    config: PeopleTabConfig = {
        title: 'Crew',
        roleAttributes: ['crew-lead', 'crew-member'],
        showCreate: false,
        showInvite: false,
        showNewOpportunity: false,
        showCreateCrew: true,
        showJobs: false,
        showRoleFilter: true,
    };
}